<div class="d-flex justify-content-between">
  <h2 class="pageTitle" data-testid="pageTitle">Packages and Add-ons</h2>
  @if (canShowChangeInventory()) {
    <div class="medium changePackageButton">
      <div class="float-right">
        <app-button
          id="btnChangePackagesandAddOns"
          buttonStyle="primary"
          noContentPadding="true"
          label="CHANGE PACKAGES AND ADD-ONS"
          (clickActionEmitter)="changeInventory()"
        >
        </app-button>
      </div>
    </div>
  }
</div>
<div class="row medium titleDivision">
  <div class="col-md-12">
    <h6 class="packages-subtext" data-testid="pageTitleSubTxt">
      This is a view of your assigned and remaining packages and add-ons.
    </h6>
    <h6 class="packages-subtext" data-testid="pageTitleSubTxt2">
      For information related to any WISP purchases, please access your invoice in the Billing tab.
    </h6>
  </div>
</div>
@if (showWLPPackages()) {
  <app-wlp-inventory-table
    [WLPPackages]="WlpPackages"
    [WLPAddOns]="WlpAddOns"
    [OrgProfile]="OrgProfile"
    (PackagePoolSelected)="packageSelected($event)"
  >
  </app-wlp-inventory-table>
}

@if (showDirectPackages()) {
  <app-direct-inventory-table
    data-testid="pkgTable"
    [Heading]="directPackagesHeading"
    [QuantityColumnHeading]="'Seats'"
    [Subtext]="directPackagesSubtext"
    [PackageList]="RnPackages"
    [Loading]="Loading"
    [OrgProfile]="OrgProfile"
    [PkgConfigInfo]="PkgConfigInfo"
    (PackagePoolSelected)="packageSelected($event)"
  >
  </app-direct-inventory-table>
}

@if (showDirectAddons()) {
  <app-direct-inventory-table
    data-testid="addonsTable"
    [IsAddOns]="isAddonsFlag"
    [Heading]="directAddonsHeading"
    [QuantityColumnHeading]="'Quantity'"
    [Subtext]="directAddonsSubtext"
    [PackageList]="RnAddOns"
    [Loading]="Loading"
    [OrgProfile]="OrgProfile"
    [PkgConfigInfo]="PkgConfigInfo"
    (PackagePoolSelected)="packageSelected($event)"
  >
  </app-direct-inventory-table>
}
